import type { ShiftSlotStatus } from '../../domain/dailyShiftSlot';
import type { DailyShiftSlotRepository } from './ports/DailyShiftSlotRepository';

export interface UpdateSlotStatusInput {
  year: number;
  month: number;
  status: ShiftSlotStatus;
  recruitmentStartAt?: string | null;
  deadlineAt?: string | null;
}

export interface UpdateSlotStatusOutput {
  success: boolean;
  errors?: string[];
}

/**
 * シフト枠ステータスを更新するUseCase
 * @param repository DailyShiftSlotRepository リポジトリインスタンス
 * @param input UpdateSlotStatusInput 更新データ
 * @returns Promise<UpdateSlotStatusOutput> 更新結果
 */
export async function updateSlotStatus(
  repository: DailyShiftSlotRepository,
  input: UpdateSlotStatusInput
): Promise<UpdateSlotStatusOutput> {
  try {
    await repository.updateStatus({
      year: input.year,
      month: input.month,
      status: input.status,
      recruitmentStartAt: input.recruitmentStartAt,
      deadlineAt: input.deadlineAt,
    });
    return { success: true };
  } catch (error) {
    const errorMessage = error instanceof Error ? error.message : 'ステータス更新に失敗しました';
    return { success: false, errors: [errorMessage] };
  }
}
